import { css } from '@emotion/react';
import { ThemeType } from 'types';

export const stylesInit = (theme: ThemeType) => css`
  display: flex;
  width: calc(100% - 2.5rem);
  padding: 0.75rem 1.25rem;
  border-top: 1px solid ${theme['grey-70']};
`;
